module.exports = __webpack_public_path__ + "static/media/boo.27363a0b.jpg";